import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-maintenance-screen',
  standalone: true,
  imports: [CardModule, ButtonModule],
  template: `
    <div class="maintenance-overlay" aria-label="maintenance-screen">
      <p-card styleClass="maintenance-card">
        <div class="maintenance-content">
          <i class="pi pi-wrench text-6xl text-primary"></i>
          <h2 class="text-2xl font-bold m-0">Maintenance en cours</h2>
          <p class="text-700 m-0 line-height-3">{{ message }}</p>
          <p-button
            label="Reessayer"
            icon="pi pi-refresh"
            (click)="retry.emit()"
            severity="primary">
          </p-button>
        </div>
      </p-card>
    </div>
  `,
  styles: [`
    .maintenance-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 9999;
      background: var(--surface-ground);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .maintenance-card {
      max-width: 500px;
      width: 90%;
    }

    .maintenance-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      padding: 1rem;
      text-align: center;
    }
  `]
})
export class MaintenanceScreenComponent {
  @Input() message = '';
  @Output() retry = new EventEmitter<void>();
}
